import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoginService } from '../authentication/login.service';
import { ThisReceiver } from '@angular/compiler';
import { LocalStorageService } from '../helper/local-storage.service';

@Injectable()
export class CheckAlreadyLogin implements CanActivate {

    loading = false; 

    constructor(
        private router: Router,
        private loginService:LoginService,
        private localStorageService: LocalStorageService
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if(this.loginService.isLoggedIn == true){
            let kyc_details = this.localStorageService.getLocalStorage('kyc_details');
            if(kyc_details.kyc_completed){
                this.router.navigate(['/dashboard']);
            }else{
                if(kyc_details.kyc_pending_from_step == 1){
                    this.router.navigateByUrl("/intro-kyc");
                }else{
                    this.router.navigateByUrl("/kyc/"+kyc_details.kyc_pending_from_step);
                }
            }
        }
        return true;
    }
}